import { Link } from 'react-router-dom';

interface HeroSectionProps {
  title: string;
  subtitle: string;
  description: string;
}

export default function HeroSection({ title, subtitle, description }: HeroSectionProps) {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20depiction%20of%20Asian%20landscapes%20merging%20traditional%20and%20modern%20elements%2C%20warm%20coral%20and%20golden%20tones%2C%20ink%20wash%20painting%20style%20with%20subtle%20geometric%20patterns%2C%20soft%20gradient%20from%20dark%20top%20to%20warm%20bottom%2C%20textured%20artistic%20background%20with%20Asian%20motifs&width=1920&height=1080&seq=hero-bg-asia-01&orientation=landscape"
          alt="亚洲专区背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 text-center py-20 md:py-24">
        <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white mb-4 tracking-tight">
          {title}
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl text-white/90 font-light mb-6 max-w-2xl mx-auto">
          {subtitle}
        </p>
        <p className="text-sm md:text-base text-white/70 max-w-xl mx-auto mb-10 leading-relaxed">
          {description}
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <Link
            to="/category/dongya"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap shadow-lg shadow-primary-500/30"
          >
            探索亚洲
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full border-2 border-white/40 text-white font-semibold text-sm md:text-base hover:bg-white/15 hover:border-white/70 transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}